import { Breakpoints } from '@lichtblick/theme';
import styled from 'styled-components';
export const PageContainer = styled.main`
  margin: 0 auto;
  max-width: ${Breakpoints.Max}px;
`;

//# sourceMappingURL=PageContainer.js.map